import React, {Component} from 'react';
import {Label, List, Message} from 'semantic-ui-react';

class TicketProductList extends Component {
    render() {
        return (
            <div>
                {
                    this.props.products.length === 0 ? <Message icon='bell' header='No hay información registrada'/> :
                        <List divided>
                            {this.props.products.map(item => {
                                return (<List.Item key={item.id}>
                                    <List.Content>
                                        <Label circular>{item.quantity} Unids.</Label> {item.product.name}
                                    </List.Content>
                                </List.Item>)
                            })}
                        </List>
                }
            </div>
        );
    }
}

export default TicketProductList;



// WEBPACK FOOTER //
// ./src/components/services/TicketProductList.js